import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDetectClickOutside } from 'react-detect-click-outside';

import Sort from "./filter/Sort";
import styles from "../../assets/stylesheets/sass/Filter.module.scss";
import MultipleChoice from "./filter/MultipleChoice";
import Radiobutton from "./filter/Radiobutton";

import filter_icon from "../../assets/icons/filter.svg";

export default function Filter({data, system, result, placeholder="Filters", placeholder_hide="Verberg alles", placeholder_show="Toon alles"}){

    const [showFilter, setShowFilter] = useState(false);
    const [filteredData, setfilteredData] = useState({});

    const refNotifications = useDetectClickOutside({ onTriggered: function(){setShowFilter(false)} });

    const addToFilteredData = (key, data) => {
        let tmp = {...filteredData};
        tmp[key] = data
        setfilteredData(tmp)

        let combinedArrays = []

        Object.keys(tmp).forEach(key => {
            combinedArrays.push(tmp[key])
        });

        let resultFilter = commonElementsOfArray(combinedArrays);

        if(Object.keys(tmp).includes("Sorteren")){
            resultFilter.sort((a, b) => tmp.Sorteren.indexOf(a) - tmp.Sorteren.indexOf(b));
        }

        result(resultFilter);
    }

    const commonElementsOfArray = (arrays) => {
        if(arrays.length > 0){
            var result = arrays.shift().filter(function(v) {
                return arrays.every(function(a) {
                    return a.indexOf(v) !== -1;
                });
            });
            return result;
        }    
    }

    return (
        <>
        <div style={{position:"relative", width:"fit-content"}} ref={refNotifications}>
            <button onClick={()=>{setShowFilter(true)}} className={styles.filter_button}><img src={filter_icon} alt="icon"/>{placeholder}</button>

            
            <div className={styles.filter_container} style={!showFilter ? {display:"none"} : {}}>
                {Object.keys(system).map((v, i)=>{
                    return (
                    <div key={i} className={styles.filter_option}>
                        <section className={styles.subtitle}><p className={styles.filter_subtitle}>{v}</p></section>
                        {system[v].type === "sort" &&
                            <Sort system={system[v]} data={data} returnedArray={(val)=>addToFilteredData(v, val)}/>
                        }

                        {system[v].type === "multiplechoice" &&
                            <MultipleChoice system={system[v]} data={data} returnedArray={(val)=>addToFilteredData(v, val)} placeholder_hide={placeholder_hide} placeholder_show={placeholder_show}/>
                        }

                        {system[v].type === "radiobutton" &&
                            <Radiobutton system={system[v]} data={data} returnedArray={(val)=>addToFilteredData(v, val)} placeholder={placeholder_show}/>
                        }
                    </div>
                    )
                })}
            </div>
            
        </div>
        </>
    )
}